import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';

import { AjsResponse, wrapAjs } from '../ajs-response';
import { InventoryB2CEventDetail } from './inventory-b2c-api.types';

/**
 * InventoryB2CApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/InventoryB2CApiService/inventoryB2CApi.service.js.
 *
 * Handles B2C inventory queries for events.
 */
const INVENTORY_B2C_BASE_V2 = '/v2/api/b2c/inventories';

@Injectable({ providedIn: 'root' })
export class InventoryB2CApiService {
  private readonly http = inject(HttpClient);

  /**
   * GET /v2/api/b2c/inventories?eventIds={eventId}
   * Returns the detail of a single event from B2C inventory.
   * Filters the response payload and returns the matching event, or rejects if not found.
   */
  detail(eventId: number | string): Promise<AjsResponse<InventoryB2CEventDetail>> {
    return wrapAjs(
      this.http
        .get<{ payload: InventoryB2CEventDetail[] }>(INVENTORY_B2C_BASE_V2, {
          params: { eventIds: String(eventId) },
        })
        .pipe(
          map((response) => {
            const eventSummary = response.payload?.filter((event) => String(event.eventId) === String(eventId))?.[0];

            if (!eventSummary) {
              throw new Error(`Event ${eventId} not found in B2C inventory`);
            }

            return eventSummary;
          }),
        ),
    );
  }
}
